<template>
  <div class="condition">
    <Header title="教学课程查询" type="0" route="/homeIndex" />
    <div >
      <van-cell
        title="学年学期"
        is-link
        icon="label-o"
        @click="xnxqPop = true"
        :value="xnxq.mc"
      />
      <van-cell
        title="校区"
        is-link
        icon="label-o"
        @click="xqPop = true"
        :value="form.xq"
      />
      <van-cell
        title="周次"
        is-link
        icon="label-o"
        @click="zcPop = true"
        :value="form.zc"
      />
      <van-cell
        title="星期"
        is-link
        icon="label-o"
        @click="xingqPop = true"
        :value="form.xingq"
      />
     <!--
        <van-cell
        title="时间"
        is-link
        icon="label-o"
        @click="timePop = true"
        :value="form.jc"
      />
     -->
     <van-cell
        title="时间节次"
        is-link
        icon="label-o"
        @click="onShow();"
        :value="form.jc"
      />
       <van-cell
        title="功能区"
        is-link
        icon="label-o"
        @click="dgnqPop = true"
        :value="form.dgnq"
      />
      <van-cell
        title="场馆"
        is-link
        icon="label-o"
        @click="jxlPop = true"
        :value="form.jxl"
      />
     <van-field
        v-model="lcxx"
        label="楼层"
        left-icon="label-o"
        input-align="right"
        placeholder="请点击填写"
      />
      <van-field
        v-model="jsxx"
        label="教师信息"
        left-icon="label-o"
        input-align="right"
        placeholder="请点击填写"
      />
    </div>
    <div class="btn">
      <van-button type="primary" block color="#7469F8" @click="search"
        >查询</van-button
      >
    </div>
     <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
        @cancel="show = false"
      />
    </van-popup>
    <!-- 学年学期 -->
    <van-popup v-model="xnxqPop" position="bottom">
      <van-picker
        :columns="xnxqList"
        :item-height="35"
        show-toolbar
        @cancel="xnxqPop = false"
        @confirm="xnxqConfirm"
      ></van-picker>
    </van-popup>
    <!-- 校区 -->
    <van-popup v-model="xqPop" position="bottom">
      <van-picker
        :columns="xqList"
        :item-height="35"
        show-toolbar
        @cancel="xqPop = false"
        @confirm="xqConfirm"
      ></van-picker>
    </van-popup>
     <!-- 多功能去 -->
    <van-popup v-model="dgnqPop" position="bottom">
      <van-picker
        :columns="dgnqList"
        :item-height="35"
        show-toolbar
        @cancel="dgnqPop = false"
        @confirm="dgnqConfirm"
      ></van-picker>
    </van-popup>
    <!-- 教学楼 -->
    <van-popup v-model="jxlPop" position="bottom">
      <van-picker
        :columns="jxlList"
        :item-height="35"
        show-toolbar
        @cancel="jxlPop = false"
        @confirm="jxlConfirm"
      ></van-picker>
    </van-popup>
    <!-- 周次 -->
    <van-popup v-model="zcPop" position="bottom">
      <van-picker
        :columns="weekList"
        :item-height="35"
        show-toolbar
        @cancel="zcPop = false"
        @confirm="zcConfirm"
      ></van-picker>
    </van-popup>
    <!-- 时间节次 -->
    <van-popup v-model="timePop" position="bottom">
      <van-picker
        :columns="timeList"
        :item-height="35"
        show-toolbar
        @cancel="timePop = false"
        @confirm="timeConfirm"
      ></van-picker>
    </van-popup>
     <!-- 星期 -->
    <van-popup v-model="xingqPop" position="bottom">
      <van-picker
        :columns="xingqList"
        :item-height="35"
        show-toolbar
        @cancel="xingqPop = false"
        @confirm="xingqConfirm"
      ></van-picker>
    </van-popup>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      type: this.$route.query.id,
      xnxqPop: false,
      zcPop: false,
      timePop: false,
      xqPop: false,
      jxlPop: false,
      xingqPop: false,
      show:false,
      dgnqPop:false,
      xnxqList: [],
      xqList: [],
      dgnqList:[],
      jxlList: [],
      roomList: ["公共教室", "实验室"],
      xingqList:[{'value':'1','text':'星期一'},{'value':'2','text':'星期二'},{'value':'3','text':'星期三'},{'value':'4','text':'星期四'},{'value':'5','text':'星期五'},{'value':'6','text':'星期六'},{'value':'7','text':'星期七'}],
      timeList:[],
      weekList:[],
      lcxx:'',
      form: {
        xnxq: ""
      },
      xnxq: {},
      skyx: {},
      jsxx: "",
      initJxlList:{},
      initXqList:{},
      initTimeList:{},
      initZcList:{},
      initXnxqList:{},
      initGnqList:{},
      valueList: {
        label: "起止节次",
        value: "1",
        item: ['第一节','第二节','第三节','第四节']
      },
      startAndEndJCList: [
        {
          values: [],
          className: "column1"
        },
        {
          values: [],
          className: "column2",
          defaultIndex: 1
        }
      ],
    };
  },
  created() {
    // 获取学年学期
    //this.getXnxq();
    //初始化数据
    this.initData();
  },
  methods: {
    //初始化数据
    async initData(){
      const params = {
          xnxq:'',
        }
       const res = await Api.initJxkbcxData(params);
       this.initJxlList = res.data.jxlList;
       this.initXqList = res.data.xqList;
       this.initTimeList = res.data.sjList;
       this.initZcList = res.data.zcList;
       this.initXnxqList = res.data.xnxqList;
       this.initGnqList = res.data.gnqList;
       this.setXnxq();
       this.setSchoolObj();
       this.setJxlObj();
       this.setTimeObj();
       this.setWeekObj();
       this.setGnqObj();
       if(this.$route.query.isBack&&this.$route.query.isBack=='1'){
          let alJc = this.$store.state.teachFindEcach.jc;
         if(alJc!=""){
            let alJcT = (alJc+"").split("-")[0]+"节,"+ (alJc+"").split("-")[1]+"节";
            this.onConfirm(alJcT);
         }
         let alXingq = this.$store.state.teachFindEcach.xingq;
         if(alXingq!=""){
            this.xingqConfirm(this.xingqList[parseInt(alXingq)-1]);
         }
         let alxnxq = this.$store.state.teachFindEcach.xnxq;
         if(alxnxq!=""){
           for(let i=0;i<this.xnxqList.length;i++){
            if(alxnxq==this.xnxqList[i].value){
              this.xnxqConfirm(this.xnxqList[i]);
              break;
            }
           }
         }
         let alxqid = this.$store.state.teachFindEcach.xqid;
         if(alxqid!=""){
           for(let i=0;i<this.xqList.length;i++){
            if(alxqid==this.xqList[i].value){
              this.xqConfirm(this.xqList[i]);
              break;
            }
           }
         }
         let alzc = this.$store.state.teachFindEcach.zc;
         if(alzc!=""){
           this.zcConfirm(this.weekList[parseInt(alzc)-1]);
         }

         let allcxx = this.$store.state.teachFindEcach.lcxx;
         if(allcxx!=""){
           this.lcxx = allcxx;
         }

         let aljsxx = this.$store.state.teachFindEcach.jsxx;
         if(aljsxx!=""){
           this.jsxx = aljsxx;
         }

         let aljxl = this.$store.state.teachFindEcach.jxl;
         if(aljxl!=''){
            for(let i=0;i<this.jxlList.length;i++){
            if(aljxl==this.jxlList[i].value){
              this.jxlConfirm(this.jxlList[i]);
              break;
            }
           }
         }

         let algnq = this.$store.state.teachFindEcach.gnq;
         if(algnq!=""){
           for(let i=0;i<this.dgnqList.length;i++){
            if(algnq==this.dgnqList[i].value){
              this.dgnqConfirm(this.dgnqList[i]);
              break;
            }
           }
         }

       }else{
         this.$store.state.teachFindEcach={};
       }
    },
    // 获取学年学期
    setXnxq() {
       for(let i=0;i<this.initXnxqList.length;i++){
         if(this.initXnxqList[i].isdqxq=='1'){
           this.xnxqDefaultIndex = i;
              this.xnxq = {
                dm: this.initXnxqList[i].xnxq01id,
                mc: this.initXnxqList[i].xqmc
              };
         }
         this.xnxqList.push({'value': this.initXnxqList[i].xnxq01id, 'text': this.initXnxqList[i].xqmc});
      }
    },
     setSchoolObj() {
       for(let i=0;i<this.initXqList.length;i++){
         this.xqList.push({'value': this.initXqList[i].xqid, 'text': this.initXqList[i].xqmc});
      }
    },
    setJxlObj() {
      for(let i=0;i<this.initJxlList.length;i++){
         this.jxlList.push({'value': this.initJxlList[i].jzwid, 'text': this.initJxlList[i].jzwmc,'szxq':this.initJxlList[i].xqid});
      }
    },
    setTimeObj() {
      for(let i=0;i<this.initTimeList.length;i++){
         this.startAndEndJCList[0].values.push(this.initTimeList[i].jc+"节");
         this.startAndEndJCList[1].values.push(this.initTimeList[i].jc+"节");
         this.timeList.push({'value': this.initTimeList[i].jc, 'text': this.initTimeList[i].jc+"节",'kssj':this.initTimeList[i].kssj,'jssj':this.initTimeList[i].jssj});
      }

    },
     setWeekObj() {
       for(let i=0;i<this.initZcList.length;i++){
         this.weekList.push({'value': this.initZcList[i].zc, 'text': this.initZcList[i].zc});
      }
    },
    setGnqObj() {
       for(let i=0;i<this.initGnqList.length;i++){
         this.dgnqList.push({'value': this.initGnqList[i].gnqid, 'text': this.initGnqList[i].gnqmc,'xqid':this.initGnqList[i].xqid});
      }
    },
    // 弹出弹框
    onShow() {
      this.valueList.value = "sjjc";
      this.valueList.item = this.startAndEndJCList;
      this.valueList.label = "起止节次(小节)";
      this.show = true;
    },
    xnxqConfirm(value) {
      this.xnxq.mc = value.text;
      this.xnxq.dm = value.value;
      this.xnxqPop = false;
    },
    xqConfirm(e) {
      this.form.xq = e;
      this.xqPop = false;
    },
    jxlConfirm(e) {
      this.form.jxl = e;
      this.jxlPop = false;
    },
    zcConfirm(e) {
      this.form.zc = e;
      this.zcPop = false;
    },
    timeConfirm(e) {
      this.form.jc = e;
      this.timePop = false;
    },
    xingqConfirm(e) {
      this.form.xingq = e;
      this.xingqPop = false;
    },
    roomConfirm(e) {
      this.form.room = e;
      this.roomPop = false;
    },
    dgnqConfirm(e) {
      this.form.dgnq = e;
      this.dgnqPop = false;
    },
    onConfirm(value,index,val){
      if(value!=""){
         let vl1 = ((value+"").split(",")[0]).slice(0,2);
         let vl2 = ((value+"").split(",")[1]).slice(0,2);
         if(parseInt(vl2)<parseInt(vl1)){
            this.$toast.fail("截至节次不能大于起始节次！");
            return;
         }
         let starTime = "";
         let endTime = "";
         for(let i=0;i<this.initTimeList.length;i++){
           var vl = this.initTimeList[i].jc;
           if(vl==vl1){
              starTime = this.initTimeList[i].kssj;
           }
           if(vl==vl2){
             endTime = this.initTimeList[i].jssj;
           }
         }
         this.form.jc = {'value':(vl1+"-"+vl2),'text':(vl1+"-"+vl2+"节 （"+starTime+"-"+endTime+"）")};
         this.show = false;
      }

    },
    search() {
      if (this.jsxx == ""&&(!this.form.jxl||this.form.jxl.value=='')&&(!this.form.dgnq||this.form.dgnq.value=='')) {
        this.$toast.fail("教工号(姓名)或者功能区或者教学楼必须要填写或者选择一项！");
        return;
      }
      if(!this.xnxq||this.xnxq.dm==''){
        this.$toast.fail("请选择学年学期！");
        return;
      }
      this.$router.push({
        path: "/teacher/searchCurContex",
        query: {
          xnxq: this.xnxq.dm,
          xqid: this.form.xq?this.form.xq.value:"",
          zc: this.form.zc?this.form.zc.value:"",
          xingq: this.form.xingq?this.form.xingq.value:"",
          jc: this.form.jc?this.form.jc.value:"",
          lcxx: this.lcxx,
          jsxx:this.jsxx,
          jxl:this.form.jxl?this.form.jxl.value:"",
          gnq:this.form.dgnq?this.form.dgnq.value:""
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
.condition {
  .btn {
    position: fixed;
    bottom: 1.25rem;
    padding: 0 1.25rem;
    width: 100%;
    left: 0;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/teachCuseFind/teaChFind.vue